import { DeleteRowConfirmationDialog } from "@/components/ax/dataTable/DeleteRowConfirmationDialog";
import { PermissionChecker2 } from "@/components/permission/PermissionChecker2";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { showSuccess, showApiError } from "@/lib/toast";
import { deleteScreenSize } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

type Props = {
  screenSizeId: string;
};

export const DeleteScreenSizeButton = ({ screenSizeId }: Props) => {
  const { t } = useTranslation();
  const { goToScreenSize } = useAppNavigate();
  const activeFirm = useSelector(selectActiveFirm);

  const deleteMutation = useMutation({
    mutationFn: () => deleteScreenSize(screenSizeId, String(activeFirm?.firmGuid)),
    onSuccess: () => {
      showSuccess(t("common.deletedSuccess"));
      goToScreenSize();
    },
    onError: showApiError,
  });

  return (
    <PermissionChecker2 entity="ScreenSize" rights={["Delete"]}>
      <DeleteRowConfirmationDialog
        onConfirmDelete={() => deleteMutation.mutate()}
        isLoading={deleteMutation.isPending}
      />
    </PermissionChecker2>
  );
};
